import axios from "axios";
import React, { useRef, useState } from "react";
import { FaPlus, FaTimes, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";
import callForwarding from "../assets/video/Call-Forwarding-SD.mp4";

const ParaLegal = () => {
  const { token } = useSelector((state) => state.token);
  const { url, user } = useSelector((state) => state.user);
  const successToast = (message) => toast.success(message);
  //
  const [tabIndex, setTabIndex] = useState(1);
  const changeTabIndex = (current) => {
    if (current === tabIndex) {
      setTabIndex(null);
    } else {
      setTabIndex(current);
    }
  };
  //
  const callInputTemplate = {
    Agent_Number: "",
    How_many_calls_have_you_received: "",
    Do_you_have_a_screenshot_of_the_received_calls: "",
  };
  const [callInputs, setCallInputs] = useState([callInputTemplate]);
  const addMoreCallInputs = () => {
    setCallInputs([...callInputs, callInputTemplate]);
  };
  const deleteCallInput = (index) => {
    setCallInputs((prevInputs) => prevInputs.filter((_, i) => i !== index));
  };
  const handleCallInputChange = (index, field, value) => {
    setCallInputs((prevInputs) =>
      prevInputs.map((input, i) =>
        i === index ? { ...input, [field]: value } : input,
      ),
    );
    //
    setCallInputErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      if (newErrors[index]) {
        newErrors[index] = { ...newErrors[index], [field]: undefined };
      }
      return newErrors;
    });
  };
  const [callInputErrors, setCallInputErrors] = useState([]);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3A, setLoading3A] = useState(false);
  const [loading3B, setLoading3B] = useState(false);
  const validateCallInputs = async () => {
    const errors = [];

    callInputs.forEach((input, index) => {
      const rowErrors = {};

      if (!input.Agent_Number.trim()) {
        rowErrors.Agent_Number = "Number is required.";
      } else if (!/^\d{10}$/.test(input.Agent_Number.trim())) {
        rowErrors.Agent_Number = "Must be a valid 10-digit number.";
      }

      if (!input.How_many_calls_have_you_received.trim()) {
        rowErrors.How_many_calls_have_you_received =
          "Select how many calls you received.";
      }

      if (!input.Do_you_have_a_screenshot_of_the_received_calls.trim()) {
        rowErrors.Do_you_have_a_screenshot_of_the_received_calls =
          "Select Yes or No.";
      }

      errors.push(rowErrors);
    });

    const hasErrors = errors.some((err) => Object.keys(err).length > 0);

    if (hasErrors) {
      setCallInputErrors(errors);
      return false; // prevents form submission
    }
    setCallInputErrors([]);

    //
    try {
      setLoading1(true);
      const data = [
        {
          Lead_Name: user.id,
          Title: "Creditor & Agent Calls",
          Client_Comments: "Report harassing phone calls",
          Creditor_And_Agent_Calls: callInputs,
          Department: "Paralegal",
        },
      ];

      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal`,
        { data },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );

      if (res.status === 201) {
        successToast("Data submitted.");
        setCallInputs([callInputTemplate]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading1(false);
    }
  };

  //
  const [visitInputs, setVisitInputs] = useState({
    agentVisit: "",
    still: "",
    callNow: "",
    agentNumber: "",
    agentName: "",
    notification: "",
    message: "",
  });
  const handleVisitInputs = (e) => {
    const { name, value } = e.target;
    setVisitInputs({
      ...visitInputs,
      [name]: value,
    });
    setVisitInputsErrors({
      ...visitInputsError,
      [name]: "",
    });
  };
  //
  const [visitInputsError, setVisitInputsErrors] = useState({});
  const submitVisitInputs = async () => {
    const {
      agentVisit,
      still,
      callNow,
      agentNumber,
      agentName,
      notification,
      message,
    } = visitInputs;

    const newErrors = {};

    // Validate agentVisit
    if (!["yes", "no"].includes(agentVisit.toLowerCase().trim())) {
      newErrors.agentVisit = "Agent visit must be 'yes' or 'no'";
    }

    // Conditional validation
    if (agentVisit.toLowerCase().trim() === "yes") {
      if (!still.toLowerCase().trim()) {
        newErrors.still = "Still image is required when agent visit is 'yes'.";
      }
    }

    // Required fields
    if (!callNow.toLowerCase().trim())
      newErrors.callNow = "Call Now is required.";
    if (!agentNumber.toLowerCase().trim()) {
      newErrors.agentNumber = "Agent number is required.";
    } else if (!/^\d{10}$/.test(agentNumber.toLowerCase().trim())) {
      newErrors.agentNumber = "Agent number must be a 10-digit number.";
    }

    if (!agentName.toLowerCase().trim())
      newErrors.agentName = "Agent name is required.";
    if (!notification.toLowerCase().trim())
      newErrors.notification = "Notification is required.";
    if (!message.toLowerCase().trim())
      newErrors.message = "Message is required.";

    // If any errors exist, update the state and stop
    if (Object.keys(newErrors).length > 0) {
      setVisitInputsErrors(newErrors);
      return;
    }

    // Clear previous errors if validation passes
    setVisitInputsErrors({});

    // Proceed with form submission logic
    try {
      setLoading2(true);
      const data = [
        {
          Lead_Name: user.id,
          Title: "Creditor & Collection Agent Visits",
          Have_you_had_a_creditor_or_Agent_visit: agentVisit,
          Name_of_the_creditor: agentName,
          Provide_the_collection_agent_number: agentNumber,
          Do_you_need_us_to_call_you_as_soon_as_possible: callNow,
          Have_you_received_a_notification_of_a_visit: notification,
          Is_the_Agent_still_at_your_address: still,
          You_can_copy_and_paste_the_message: message,
          Client_Comments: "Report creditor visits to my address",
          Department: "Paralegal",
        },
      ];
      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal`,
        { data },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.status === 201) {
        successToast("Data submitted.");
        setVisitInputs({
          agentVisit: "",
          still: "",
          callNow: "",
          agentNumber: "",
          agentName: "",
          notification: "",
          message: "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading2(false);
    }
  };
  //
  const videoRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => {
    setModalVisible(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };
  const submitIssue = async (option) => {
    try {
      if (option.toLowerCase() === "yes") {
        setLoading3A(true);
      } else {
        setLoading3B(true);
      }
      const data = [
        {
          Lead_Name: user.id,
          Title: "Call Forwarding",
          My_call_forwarding_is_not_working: option,
          Client_Comments: "Technical issue with call forwarding",
          Department: "Paralegal",
        },
      ];
      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal`,
        { data },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );
      if (res.status === 201) {
        successToast("Data submitted.");
        if (option.toLowerCase() === "yes") {
          setModalVisible(true);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading3A(false);
      setLoading3B(false);
    }
  };
  //
  const [otherIssue, setOtherIssue] = useState("");
  const handleOtherIssue = (e) => {
    setOtherIssue(e.target.value);
    setOtherIssueError("");
  };
  const [otherIssueError, setOtherIssueError] = useState("");
  const [file, setFile] = useState(null);
  const handleFile = (e) => {
    setFile(e.target.files[0]);
    setFileError("");
  };
  const [fileError, setFileError] = useState("");
  const fileInput = useRef(null);
  const submitFile = async () => {
    if (otherIssue === "") {
      setOtherIssueError("Please enter the issue you are facing");
    } else if (!file) {
      setFileError("Please attach a file.");
    } else {
      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "video/mp4",
        "video/webm",
        "video/ogg",
      ];
      if (!allowedTypes.includes(file.type)) {
        setFileError(
          "Only PDF, PNG, JPEG, or video files (MP4, WebM, OGG) are allowed.",
        );
        return;
      } else {
        const data = [
          {
            Title: "Other creditor issue",
            Client_Comments: otherIssue,
            Lead_Name: user.id,
            Added_By: user.Full_Name,
            Department: "Paralegal",
          },
        ];
        const res = await axios.post(
          `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal`,
          { data },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Zoho-oauthtoken ${token}`,
            },
          },
        );
        if (res.status === 201) {
          const formdata = new FormData();
          formdata.append("file", file);
          const fileRes = await axios.post(
            `${url}/proxy?url=https://www.zohoapis.in/crm/v5/SD_Portal/${res.data.data[0].details.id}/Attachments`,
            formdata,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Zoho-oauthtoken ${token}`,
              },
            },
          );
          if (fileRes.status === 200) {
            setFile(null);
            setOtherIssue("");
            successToast("Data submitted.");
          }
        }
      }
    }
  };
  return (
    <>
      <div className="journal container p-2">
        <div className="text-center my-4">
          <h2>Paralegal - calls & harassments</h2>
          <p>
            You must tell us about any legal action that your creditor take when
            they happen
          </p>
        </div>

        <div
          className="border rounded d-flex align-items-lg-center align-items-stretch justify-content-between flex-lg-row flex-column gap-2 my-4 p-md-4 p-2"
          style={{ background: "#eee" }}
        >
          <p>
            *For any legal files like notice, legal letters and harassment files
            to be uploaded or legal journal entries needs to be done via the{" "}
            <br />
            <Link
              to="/advocatelawyer"
              className="fw-bold text-decoration-underline"
            >
              "Legal matters"
            </Link>{" "}
            page.
          </p>

          <div className="d-flex align-items-center justify-content-end gap-2">
            <a href={`tel:02268762652`} className="white-button">
              call
            </a>
            <a
              href={`https://wa.me/9136924980`}
              target="_blank"
              className="white-button"
            >
              chat
            </a>
            <a href="mailto:advocate@singledebt.in" className="white-button">
              Email
            </a>
          </div>
        </div>

        {/*  */}
        <div>
          <div className={`para-legal-tab ${tabIndex === 1 ? "active" : ""}`}>
            <div
              className="para-legal-tab-head"
              onClick={() => changeTabIndex(1)}
            >
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h2 className="fw-bold">Creditor & Agent Calls</h2>
                <div>
                  {tabIndex === 1 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              <ul>
                <li>Report harassing phone calls</li>
                <li>Track call frequency and patterns</li>
                <li>Submit call evidence</li>
              </ul>
            </div>
            <div className="para-legal-tab-body">
              {callInputs.map((item, index) => {
                return (
                  <div key={index}>
                    <div className="para-legal-flex">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <h2 className="fw-bold">Creditor {index + 1}</h2>
                        {callInputs.length === 1 ? (
                          ""
                        ) : (
                          <button
                            className="button enroll-button-flex"
                            onClick={() => deleteCallInput(index)}
                          >
                            Delete <FaTrash />
                          </button>
                        )}
                      </div>
                      <div>
                        <label>Input the number that is calling you</label>
                        <input
                          type="number"
                          className="form-input para-legal-input"
                          value={item.Agent_Number}
                          onChange={(e) =>
                            handleCallInputChange(
                              index,
                              "Agent_Number",
                              e.target.value,
                            )
                          }
                        />
                        {callInputErrors[index]?.Agent_Number && (
                          <small className="text-danger">
                            {callInputErrors[index].Agent_Number}
                          </small>
                        )}
                      </div>
                      <div>
                        <label>
                          How many calls have you received from this number?
                        </label>
                        <select
                          className="form-input para-legal-input"
                          value={item.How_many_calls_have_you_received}
                          onChange={(e) =>
                            handleCallInputChange(
                              index,
                              "How_many_calls_have_you_received",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">Select</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5+">5+</option>
                        </select>
                        {callInputErrors[index]
                          ?.How_many_calls_have_you_received && (
                          <small className="text-danger">
                            {
                              callInputErrors[index]
                                .How_many_calls_have_you_received
                            }
                          </small>
                        )}
                      </div>
                      <div className="mb-0">
                        <label>
                          Do you have a screenshot of the received calls?
                        </label>
                        <select
                          className="form-input para-legal-input"
                          value={
                            item.Do_you_have_a_screenshot_of_the_received_calls
                          }
                          onChange={(e) =>
                            handleCallInputChange(
                              index,
                              "Do_you_have_a_screenshot_of_the_received_calls",
                              e.target.value,
                            )
                          }
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                        {callInputErrors[index]
                          ?.Do_you_have_a_screenshot_of_the_received_calls && (
                          <small className="text-danger">
                            {
                              callInputErrors[index]
                                .Do_you_have_a_screenshot_of_the_received_calls
                            }
                          </small>
                        )}
                      </div>
                    </div>
                    <hr />
                  </div>
                );
              })}
              <div className="d-flex align-items-center justify-content-end gap-2">
                <button
                  className="white-button enroll-button-flex"
                  onClick={addMoreCallInputs}
                >
                  Add more <FaPlus />
                </button>
                <button
                  className="button enroll-button-flex"
                  onClick={validateCallInputs}
                  style={{ width: "80px" }}
                >
                  {loading1 === true ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
          {/*  */}
          <div className={`para-legal-tab ${tabIndex === 2 ? "active" : ""}`}>
            <div
              className="para-legal-tab-head"
              onClick={() => changeTabIndex(2)}
            >
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h2 className="fw-bold">Creditor & Collection Agent Visits</h2>
                <div>
                  {tabIndex === 2 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              <ul>
                <li>Report creditor visits to your address</li>
                <li>Get immediate assistance if agents are present</li>
                <li>Document visit notifications</li>
              </ul>
            </div>
            <div className="para-legal-tab-body">
              <div className="para-legal-flex">
                <div>
                  <label>Have you had a creditor or Agent visit?</label>
                  <select
                    className="form-input para-legal-input"
                    name="agentVisit"
                    value={visitInputs.agentVisit}
                    onChange={handleVisitInputs}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <small className="text-danger">
                    {visitInputsError.agentVisit}
                  </small>
                </div>
                {visitInputs.agentVisit.toLowerCase() === "yes" && (
                  <div>
                    <label>Is the Agent still at your address?</label>
                    <select
                      className="form-input para-legal-input"
                      name="still"
                      value={visitInputs.still}
                      onChange={handleVisitInputs}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    <small className="text-danger">
                      {visitInputsError.still}
                    </small>
                  </div>
                )}
                <div>
                  <label>Do you need us to call you as soon as possible?</label>
                  <select
                    className="form-input para-legal-input"
                    name="callNow"
                    value={visitInputs.callNow}
                    onChange={handleVisitInputs}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <small className="text-danger">
                    {visitInputsError.callNow}
                  </small>
                </div>
                <div>
                  <label>Can you provide the collection agent number?</label>
                  <input
                    type="tel"
                    className="form-input para-legal-input"
                    name="agentNumber"
                    value={visitInputs.agentNumber}
                    onChange={handleVisitInputs}
                  />
                  <small className="text-danger">
                    {visitInputsError.agentNumber}
                  </small>
                </div>
                <div>
                  <label>Name of the creditor</label>
                  <input
                    type="text"
                    className="form-input para-legal-input"
                    name="agentName"
                    value={visitInputs.agentName}
                    onChange={handleVisitInputs}
                  />
                  <small className="text-danger">
                    {visitInputsError.agentName}
                  </small>
                </div>
                <div>
                  <label>Have you received a notification of a visit?</label>
                  <select
                    className="form-input para-legal-input"
                    name="notification"
                    value={visitInputs.notification}
                    onChange={handleVisitInputs}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <small className="text-danger">
                    {visitInputsError.notification}
                  </small>
                </div>
                <div className="para-tab2-textrea mb-0">
                  <label>
                    You can copy and paste the message into this field
                  </label>
                  <textarea
                    className="form-input para-legal-textarea"
                    name="message"
                    value={visitInputs.message}
                    onChange={handleVisitInputs}
                  ></textarea>
                  <small className="text-danger">
                    {visitInputsError.message}
                  </small>
                </div>
              </div>
              <hr />
              <div className="text-end">
                <button className="button" onClick={submitVisitInputs}>
                  {loading2 === true ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
          {/*  */}
          <div className={`para-legal-tab ${tabIndex === 3 ? "active" : ""}`}>
            <div
              className="para-legal-tab-head"
              onClick={() => changeTabIndex(3)}
            >
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h2 className="fw-bold">Call Forwarding - Technical Issue</h2>
                <div>
                  {tabIndex === 3 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              <ul>
                <li>Technical issue with call forwarding</li>
                <li>Need assistance setting up forwarding</li>
              </ul>
            </div>
            <div className="para-legal-tab-body">
              <label className="d-block mb-2">
                Are you facing call forwarding issues?
              </label>
              <div className="d-flex align-items-center justify-content-start gap-2">
                <button
                  className="button text-center"
                  style={{ width: "100px" }}
                  onClick={() => submitIssue("yes")}
                >
                  {loading3A === true ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Yes"
                  )}
                </button>
                <button
                  className="button text-center"
                  style={{ width: "100px" }}
                  onClick={() => submitIssue("no")}
                >
                  {loading3B === true ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "No"
                  )}
                </button>
              </div>
            </div>
          </div>
          {/*  */}
          <div className={`para-legal-tab ${tabIndex === 4 ? "active" : ""}`}>
            <div
              className="para-legal-tab-head"
              onClick={() => changeTabIndex(4)}
            >
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h2 className="fw-bold">Other Creditors Issues</h2>
                <div>
                  {tabIndex === 4 ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </div>
              </div>
              <ul>
                <li>Other issues you are experiencing with creditors</li>
              </ul>
            </div>
            <div className="para-legal-tab-body">
              <div className="para-tab2-textrea mb-4">
                <label>Please enter the issue you are facing</label>
                <textarea
                  className="form-input para-legal-textarea"
                  name="message"
                  value={otherIssue}
                  onChange={handleOtherIssue}
                ></textarea>
                <small className="text-danger">{otherIssueError}</small>
              </div>
              <div>
                <label className="d-block mb-2">Please attach the file</label>
                <input
                  type="file"
                  ref={fileInput}
                  onChange={handleFile}
                  className="form-control"
                  accept=".pdf,image/*,video/mp4,video/webm,video/ogg"
                />
                <small className="text-danger">{fileError}</small>
              </div>
              <div className="text-end mt-2">
                <button className="button" onClick={submitFile}>
                  {loading3A === true ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} theme="light" />

      {/*  */}
      <div className={`custom-modal-container ${modalVisible ? "active" : ""}`}>
        <div className="custom-modal-background" onClick={closeModal}></div>
        <div className="custom-modal-box">
          <div className="header p-2">
            <p className="fw-bold text-capitalize">
              Activate Call Forwarding for Enhanced Support
            </p>
            <div style={{ cursor: "pointer" }} onClick={closeModal}>
              <FaTimes />
            </div>
          </div>
          <div className="body p-2">
            <video ref={videoRef} className="w-100" controls>
              <source src={callForwarding} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="footer p-2"></div>
        </div>
      </div>
    </>
  );
};

export default ParaLegal;
